import {Injectable, isDevMode} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import {Location} from "@angular/common";

import {Observable, Subject, tap, TimeoutError} from 'rxjs';

import {WebResponse} from "@commons/models/remote.response/WebResponse";

import {ProgressService} from '../progress/progress.service';

import {NewNavigationService} from "@shared/services/new-navigation.service";
import {SettingsService} from "@shared/services/settings.service";
import {LogInApiHttpService} from "@shared/services-http/log-in-api-http.service";
import {NewWebSocketHttpService} from "@shared/websocket/new-web-socket-http.service";
import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {
  private errorNotified = false;

  public static $errorSubject = new Subject();
  public static $timeoutSubject = new Subject();

  constructor(
    private progressService: ProgressService,
    private location: Location,
    private newNavigationService: NewNavigationService,
    private $progressService: ProgressService,
    private settingsService: SettingsService,
    private logInApiHttpService: LogInApiHttpService,
    private newWebSocketHttpService: NewWebSocketHttpService,
    private authenticationService: AuthenticationService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.logInApiHttpService.setLastRequest(JSON.stringify(req));

    const subject: Subject<HttpEvent<any>> = new Subject();
    const method = req.method;
    const inProgress = ['PUT', 'POST', 'DELETE'].indexOf(method) !== -1;

    if (inProgress)
      this.progressService.setState(true);

    req = this.trySetSessionIdHeader(req);
    req = req.clone({headers: req.headers.set('machine-id', this.settingsService.getMachineId())});
    req = req.clone({headers: req.headers.set('Cache-Control', 'no-cache')});

    next.handle(req).pipe(
      tap(respone => {
        if (respone instanceof HttpResponse)
          this.setWebSocketRoute(<HttpResponse<any>>respone);
      }))
      .subscribe({
        next: (result) => {
          const webResponse = (result as any) as WebResponse;
          if (webResponse && webResponse.ErrorCode > 0) {
            console.error(JSON.stringify(result));
          }

          if (result && result.type && inProgress) {
            this.progressService.setState(false);
          }
          subject.next(result);
        },
        error: (error) => {
          if (inProgress) {
            this.progressService.setState(false);
          }
          this.progressService.forceStop();

          this.notifyOnError(error);
          subject.error(error);
        },
        complete: () => {
          if (inProgress) {
            this.progressService.setState(false);
          }
          subject.complete();
        }
      });

    return subject.asObservable();
  }

  private trySetSessionIdHeader(httpRequest: HttpRequest<any>): HttpRequest<any> {
    if (httpRequest.url.includes('AuthenticateByToken') || httpRequest.url.includes('https://en.wikipedia.org'))
      return httpRequest;

    const sessionId = httpRequest.headers.get('SessionId');
    if (!sessionId && this.authenticationService?.sessionId) {
      httpRequest = httpRequest.clone({headers: httpRequest.headers.set('SessionId', this.authenticationService.sessionId)});
    }

    // const notification = httpRequest.headers.get('notification');
    // if (!notification) {
    //   httpRequest = httpRequest.clone({headers: httpRequest.headers.set('notification', 'true')});
    //   if(isDevMode())
    //     console.log('notification' + httpRequest.url);
    // }

    return httpRequest;
  }

  //{ notification: true }

  private notifyOnError(error: any) {
    if (this.errorNotified)
      return;

    const isErrorFromNewModule =
      this.newNavigationService.isInAuthenticationModule || this.newNavigationService.isInDataSharingModule;

    if (isErrorFromNewModule) {
      if (error instanceof TimeoutError) {
        HttpProgressInterceptor.$timeoutSubject.next(true);
      } else if (error?.status == 401 || error?.code == 401) { //Unauthorized
        this.newNavigationService.toLogout();
      } else if (error?.status >= 500 || error?.code >= 500) {
        HttpProgressInterceptor.$errorSubject.next(true);
      } else {
        return;//custom validation error to handle
      }

      this.errorNotified = true;
    }
  }

  private setWebSocketRoute(response: HttpResponse<any>) {
    if (response?.headers.has('route')) {
      let route: string | null = response.headers.get('route');
      this.newWebSocketHttpService.changeHttpRoute(route ?? 'not-set');
    }
  }
}
